"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CurrencyInsetElement = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _context = require("../../../context");

var _layout = require("../../../layout");

var _text = require("../../../text");

var _constants = require("../../constants");

var _constants2 = require("../constants");

var _constants3 = require("./constants");

var _utils = require("./utils");

var _core = require("@emotion/core");

var _excluded = ["children"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

var CurrencyContainer = (0, _context.styledWithTheme)(_layout.Row)(function (_ref) {
  var selectors = _ref.theme.selectors,
      disabled = _ref.disabled,
      error = _ref.error,
      warning = _ref.warning;
  var verticalPadding = _constants.INPUT_PADDING_DEFAULT - _constants2.BORDER_WIDTH;
  var horizontalPadding = 'S100';
  var backgroundColor = (0, _utils.getColor)(error, warning, disabled, {
    errorColor: 'red05',
    warningColor: 'yellow05',
    defaultColor: 'neutral10'
  });
  var borderColor = (0, _utils.getColor)(error, warning, disabled, {
    errorColor: 'red70',
    warningColor: 'yellow70',
    defaultColor: 'neutral50'
  });
  var cursor = disabled ? {
    cursor: 'not-allowed'
  } : {};
  return _objectSpread({
    borderRight: "2px solid ".concat(selectors.color(borderColor)),
    width: "".concat(_constants3.CURRENCY_CODE_CONTAINER_WIDTH, "px"),
    justifyContent: 'center',
    backgroundColor: selectors.color(backgroundColor),
    paddingTop: verticalPadding,
    paddingBottom: verticalPadding,
    paddingLeft: selectors.space(horizontalPadding),
    paddingRight: selectors.space(horizontalPadding)
  }, cursor);
});

var CurrencyInsetElement = function CurrencyInsetElement(_ref2) {
  var children = _ref2.children,
      rest = (0, _objectWithoutProperties2.default)(_ref2, _excluded);
  var textColor = (0, _utils.getColor)(rest.error, rest.warning, rest.disabled, {
    errorColor: 'red80',
    warningColor: 'yellow80',
    defaultColor: 'neutral70'
  });
  return (0, _core.jsx)(CurrencyContainer, rest, (0, _core.jsx)(_text.Text, {
    fontSize: "1.125rem",
    lineHeight: 1.55556,
    color: textColor
  }, children));
};

exports.CurrencyInsetElement = CurrencyInsetElement;